import React from 'react'
import { Registerform } from "../components/Registerform.js"

export function Register() {
    return (
        <div>
            <Registerform />
        </div>
    )
}

